"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.getDeptSuperior = getDeptSuperior;
exports.getDepts = getDepts;
exports.getDeptsByName = getDeptsByName;
exports.getTypeList = getTypeList;

require("core-js/modules/es6.array.of");

var _request = _interopRequireDefault(require("@/utils/request"));

function getTypeList(type) {
  return (0, _request.default)({
    url: '/api/dept/typeList?type=' + type,
    method: 'get'
  });
}

function getDepts(params) {
  return (0, _request.default)({
    url: 'api/dept',
    method: 'get',
    params: params
  });
}

function getDeptsByName(params) {
  return (0, _request.default)({
    url: 'api/dept/list',
    method: 'get',
    params: params
  });
}

function getDeptSuperior(ids) {
  if (!ids) return Promise.resolve({
    code: 200,
    data: []
  });
  var data = ids.length || ids.length === 0 ? ids : Array.of(ids);
  return (0, _request.default)({
    url: 'api/dept/superior',
    method: 'post',
    data: data
  });
}

function add(data) {
  return (0, _request.default)({
    url: 'api/dept',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/dept',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/dept',
    method: 'put',
    data: data
  });
}

var _default = {
  add: add,
  edit: edit,
  del: del,
  getDepts: getDepts,
  getDeptSuperior: getDeptSuperior,
  getDeptsByName: getDeptsByName,
  getTypeList: getTypeList
};
exports.default = _default;